export default [
  {
    label: 'Все налоговые органы',
    value: -1,
    filterFn: () => true,
  },
];
